<template>
  <section class="page-header">
    <div class="page-header__hgroup">
      <h1 class="page-header__title">SVG Icons</h1>
      <p>All icons are made with Illustrator</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProjectIconsHeader'
}
</script>
